import jsPDF from "jspdf";
import "jspdf-autotable";

export function generatePdf(values) {
  const doc = new jsPDF();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);

  doc.text("Production Daily Report PDF", 15, 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);

  const columns = ["Field", "Value"];

  const rows = [
    { field: "Date", value: values.date },
    { field: "Shift", value: values.shift },
    { field: "Production Facility", value: values.location },
    {
      field: "Raw Material Consumption",
      value: values.raw_material_consumption,
    },
    { field: "Decay", value: values.decay },
    {
      field: "Finished Products Net Weight",
      value: values.finished_products_net_weight,
    },
    { field: "Finished Pallets", value: values.finished_pallets },
    { field: "Pending Pallets", value: values.pending_pallets },
    { field: "Return", value: values.return },
    { field: "Small Calibers", value: values.small_calibers },
    // { field: "Report Status", value: values.report_status },
  ];

  let startY = 40;
  doc.autoTable({
    startY,
    head: [columns],
    body: rows.map((row) => [row.field, row.value]),
    theme: "striped",
  });

  doc.save("daily-production-report.pdf");
}
